import { useCallback } from 'react';

import { useDataService } from '../../../services/ApiDataService';
import { useRequestState } from '../../../utilities/Hooks';

const EXPORT_GEOJSON_URL = '/ipm/public/systemconfiguration/getGeoJsonMapOverlay';

export function useGeoJsonExporter() {
    const dataService = useDataService();
    const { data, isLoading, error, methods } = useRequestState();

    const exportGeoJson = useCallback((fileName) => getGeoJson(fileName, dataService, methods), [dataService, methods]);

    return {
        geoJson: data,
        isLoading,
        error,
        exportGeoJson,
    };
}

async function getGeoJson(fileName, dataService, { onInit, onLoad, onError }) {
    onInit();

    try {
        const { geoJsonFile: geoJsonFileData } = await dataService.get(EXPORT_GEOJSON_URL, {
            exportFile: true,
        });

        onLoad(geoJsonFileData);

        if (fileName) {
            const blob = new Blob([JSON.stringify(geoJsonFileData)], { type: 'text/json' });

            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.click();
        }
    } catch (e) {
        onError(e);
    }
}
